var inherit = require("../../general.js").inherit;
var HashMap = require("../../collections/hashMap.js");
var HashSet = require("../../collections/hashSet.js");

var ObservableTreeNode = require("../../observable/tree/observableTreeNode.js");
var ObservableTreeValue = require("../../observable/tree/observableTreeValue");
var ObservableTreeMap = require("../../observable/tree/observableTreeMap.js");
var ObservableTreeSet = require("../../observable/tree/observableTreeSet.js");
var ObservableTreeList = require("../../observable/tree/observableTreeList.js");

var AbstractInstance = require("./abstractInstance.js");

var InstanceBuilder = function (ancestor) {
    var self = this;
    AbstractInstance.call(this);

    this.ancestor = this.value("ancestor", false); // since ancestor can be anything, you can instantiate anything, which is good! However this will only work if you instantiate constant objects like descriptions or part of descriptions: when non-constant objects are instaniated, instanceBuilder will build the instanceTree at one moment, but when the ancestor changes, corresponding instance objects won't change in a similar way!

    this.instanceMap = new HashMap();

    this.ancestor.onChange(this, function(val, old) { // when the ancestor is updated
        if (val == null) self.isBuild = false;  // if ancestor is removed, invalidate build flag TODO: maybe entirely remove this instancebuilder, or at least remove all the instances
        else {
            self.reMapInstances(val, old); // first find a mapping for the already existing instances
            self.rebuild(); // rebuild the instance structure
        }
    });

    if (ancestor != undefined) this.ancestor(ancestor);
};
inherit(InstanceBuilder, AbstractInstance);

module.exports = InstanceBuilder;

// AutoInstance class, used by all objects that haven't an instanceClass defined.
var AutoInstance = function(root){
    AbstractInstance.call(this, root);
};
inherit(AutoInstance, AbstractInstance);
AutoInstance.$class = "AutoInstance";

// Register an instanceClass for every object of type dataClass in given path
InstanceBuilder.prototype.registerInstanceClass = function(path, dataClass, instanceClass) {
    if (!this.instanceClassMap) this.instanceClassMap = new HashMap();
    this.instanceClassMap.put({path: path, dataClass: dataClass || Object}, instanceClass || AutoInstance);     // if dataClass is not specified, accept all objects
};

InstanceBuilder.prototype.registerPersistentMember = function(path) {
    if (!this.persistentMemberPaths) this.persistentMemberPaths = new HashSet();
    this.persistentMemberPaths.add(path);
};

InstanceBuilder.prototype.rebuild = function() {
	var self = this;
    if(this.ancestor() == undefined) throw new Error("Can't build with undefined ancestor");
    console.assert(this.ancestor().isObservableTreeNode, "Can't build an instance of something that's not an observable tree node");
    if(this.isBuild) console.assert(!this.observeAncestor, "Can't update ancestor if observers have been put on it");
    if(!this.observeAncestor)
        this.ancestor().onBubble("readOnly", function(){console.error("Ancestor must not be modified or changes must be observed");});

    if (!this.isBuild) {//first time
        this.isBuild = true;
        this.instanceClassMap && this.instanceClassMap.forEach(function(rule, instanceClass){
            initializeInstanceMembers(self.ancestor(), self, self, rule.path, rule.dataClass, instanceClass); //manual for root
        });
    }

    this.template(this.ancestor());
    this.instanceClassMap && this.instanceClassMap.forEach(function(rule, instanceClass){
        instantiateInstances(self.ancestor(), self, self, rule.path, rule.dataClass, instanceClass);
    });
    getInitializedInstance(this.ancestor(), this);    //reinitialize

    // this.sanityCheck();
};

InstanceBuilder.prototype.reMapInstances = function(ancestor, oldAncestor){ // remap the already existing instances on new templates from the new ancestor
    var newInstanceMap = new HashMap();
    this.instanceMap.forEach(function(template, instance){
        var newTemplate = ancestor && ancestor.root && ancestor.root.nodeMap.get(template.$id); // if the templates has an id find a node in the new ancestor's root with the same id
        if (newTemplate) newInstanceMap.put(newTemplate, instance)
    });
    this.instanceMap = newInstanceMap;
};

InstanceBuilder.prototype.getBuilder = function(){ // TODO: maybe replace this by shadow
    return this;
};

InstanceBuilder.prototype.clone = function() {
    console.assert("TODO: implement proper instancebuilder clone");
    // var clonedObj = ObservableTreeNode.clone.apply(this, arguments); // TODO: won't work!
    // clonedObj.ancestor(this.ancestor());    // copy ancestor
    // clonedObj.build();                      // build instances of clone as well
    // return clonedObj;
};

function initializeReferences(template, instance, builder){
    //removing references
    var to_remove = [];
    var removeRefs = function(child_instance, member, key) {
        var name = member.getName();
        if(child_instance) {
            var template_exists_in_new_builder = true;
            var template_member = instance.template().collections.get(name) || (instance.template().instanceCollections && instance.template().instanceCollections.get(name));
            if(!template_member) return;
            switch(member.getType()) {
                case "value":
                    template_exists_in_new_builder = template_member() === child_instance.template();
                    break;
                case "set":
                    template_exists_in_new_builder = template_member.contains(child_instance.template());
                    break;
                case "list":
                    if(member.isOwner()) //special case: if the new template still contains the child, then it must not be removed/killed even if it's in the wrong spot
                        template_exists_in_new_builder = template_member.contains(child_instance.template());
                    else
                        template_exists_in_new_builder = template_member.get(key) === child_instance.template();
                    break;
                case "map":
                    template_exists_in_new_builder = template_member.get(key.isObservableTreeNode ? key.template() : key) === child_instance.template();
                    break;
                default:
                    throw new Error("not implemented");
            }
            if(!template_exists_in_new_builder) {
                to_remove.push({member: member, key:key, value: child_instance});
            }
        }
    };
    instance.forEachInstanceMember(removeRefs);

    to_remove.reverse();
    to_remove.forEach(function(rm) {
        switch(rm.member.getType()) {
            case "value":
                rm.member(null);
                break;
            case "set":
                rm.member.remove(rm.value);
                break;
            case "list":
            case "map":
                rm.member.remove(rm.key);
                break;
            default:
            throw new Error("not implemented");
        }
        // console.log("removing old child: ", rm.value.getPath());
    });

    //adding references
    instance.instanceCollections.forEach(function(name, instance_member){
        var member = template.collections.get(name) || (template.instanceCollections && template.instanceCollections.get(name));
            switch(member.getType()) {
                case "value":
                var child = member();
                var child_instance = getInitializedInstance(child, builder);
                if(child && child.isObservableTreeNode && child_instance && instance_member() !== child_instance)
                        instance_member(child_instance);
                    break;
                case "set":
                member.forEach(function(child){
                    var child_instance = getInitializedInstance(child, builder);
                    if(child && child.isObservableTreeNode && child_instance && !instance_member.contains(child_instance))
                        instance_member.add(child_instance);
                });
                    break;
                case "list":
                member.forEach(function(idx, child){
                    var child_instance = getInitializedInstance(child, builder);
                    if(child && child.isObservableTreeNode && child_instance && instance_member.get(idx) !== child_instance)
                        instance_member.add(idx, child_instance);

                });
                    break;
                case "map":
                member.forEach(function(key, child){
                    var key_child_instance = key.isObservableTreeNode ? getInitializedInstance(key, builder) : key;
                    console.assert(key_child_instance);
                    var child_instance = getInitializedInstance(child, builder);
                    if(child && child.isObservableTreeNode && child_instance && instance_member.get(key_child_instance) !== child_instance) {
                        instance_member.put(key_child_instance, child_instance);
                        if(builder.observeAncestor && key.isObservableTreeNode) {
                            key_child_instance.onDie("instanceBuilder"+instance.$id+"_"+name, function() {
                                var res = instance_member.remove(key_child_instance);  //hack to remove keys from map when key dies
                            });
                        }
                    }
                });
                    break;
                default:
                    throw new Error("not implemented");
            }

    });
        }

/**
 * Add all the members of the template to the instance
 * Do not yet initialize the content
 * Optionally set observers on the member of the template to update the instance
 */
function initializeInstanceMembers(template, instance, builder, path, dataClass, instanceClass){
    if (!(path && path[0])) return;
    var member = template.collections.get(path[0]) || (template.instanceCollections && template.instanceCollections.get(path[0]));
    if (instance.instanceCollections.contains(path[0])) return;

    for (var prop in template){// TODO: not really efficient! to loop over all properties of obj (including prototype chain) to figure out original property name of members
        if (template[prop] == member) break;
    }
    console.assert(!instance[prop], "Warning: instanceBuilder overrides original data fields of instance object: " + prop);
            //TODO: "if(!instance[prop])" is a hack to allow persistent members to work with undoable.js; should be removed after lib-core refactoring

            switch(member.getType()) {
                case 'value':
                    if(!instance[prop]) instance[prop] = ObservableTreeValue.createNewFunction(instance, member.getName(), member.isOwner());
                    if(builder.observeAncestor) {
                        member.onChange("instanceBuilder"+instance.$id, function() { // TODO: won't work yet
                    instance[prop](getInitializedInstance(member(), builder, path.slice(1), dataClass, instanceClass));
                        });
                    }
                    break;

                case 'set':
                    if(!instance[prop]) instance[prop] = new ObservableTreeSet(instance, member.getName(), member.isOwner());
                    if(builder.observeAncestor) {
                        member.onAdd("instanceBuilder"+instance.$id, function(element) {
                    instance[prop].add(getInitializedInstance(element, builder, path.slice(1), dataClass, instanceClass));
                        });
                        member.onRemove("instanceBuilder"+instance.$id, function(element) {
                            if(!element.isAlive() && !this.isOwner()) return;   //if the element has died, then its instance should be removed from its parent. references to the instance are automatically cleaned
                    var res = instance[prop].remove(getInstance(element, builder));
                            console.assert(res, "something should be removed");
                        });
                    }
                    break;

            case "map":
                if(!instance[prop]) instance[prop] = new ObservableTreeMap(instance, member.getName(), member.isOwner());
                if(builder.observeAncestor) {
                    member.onPut("instanceBuilder"+instance.$id, function(key, element) {
                var key_instance = key.isObservableTreeNode ?  getInitializedInstance(key, builder, path.slice(1), dataClass, instanceClass) : key;
                        instance[prop].put(
                            key_instance,
                    getInitializedInstance(element, builder, path.slice(1), dataClass, instanceClass));
                if (key_instance.isObservableTreeNode) key_instance.onDie("instanceBuilder"+instance.$id+"_"+member.getName(), function() {
                            var res = instance[prop].remove(key_instance);  //hack to remove keys from map when key dies
                        });
                    });
                    member.onRemove("instanceBuilder"+instance.$id, function(key, val) {
                        if(!val.isAlive() && !this.isOwner()) return;   //if the element has died, then its instance should be removed from its parent. references to the instance are automatically cleaned
                if(key.isObservableTreeNode && !key.isAlive()) return; //if the key has died, its instance will have died and been removed from the map
                var res = instance[prop].remove(key.isObservableTreeNode ? getInstance(key, builder) : key);
                        console.assert(res, "something should be removed");
                    });
                }
                break;

            case "list":
                if(!instance[prop]) instance[prop] = new ObservableTreeList(instance, member.getName(), member.isOwner());
                if(builder.observeAncestor) {
                    member.onAdd("instanceBuilder"+instance.$id, function(index, element) {
                        instance[prop].add(
                            index,
                    getInitializedInstance(element, builder, path.slice(1), dataClass, instanceClass));
                    });
                    member.onPut("instanceBuilder"+instance.$id, function(index, element) {
                        instance[prop].put(
                            index,
                    getInitializedInstance(element, builder, path.slice(1), dataClass, instanceClass));
                    });
                    member.onRemove("instanceBuilder"+instance.$id, function(index, element) {
                        if(!element.isAlive() && !this.isOwner()) return;   //if the element has died, then its instance should be removed from its parent. references to the instance are automatically cleaned
                        var res = instance[prop].remove(index);
                        console.assert(res, "something should be removed");
                    });
                }
                break;
            default:
                throw new Error();
            }
            instance.instanceCollections.put(member.getName(), instance[prop]); // TODO in case of persisent instance collection: add collection to normal collections map
            instance[prop].nonPersistent = true;    // TOOD

//TODO
            // instance[prop].setPersistent(false);   // make member non-persistent
            // if(builder.persistentMemberPaths) {
            //     builder.persistentMemberPaths.forEach(function(path) {
            //         var objPath = member.getObj().getPath().concat(member.getName());
            //         objPath = objPath.slice(builder.ancestor().getPath().length).join("/"); // path of template starting form the builder's ancestor
            //         if (objPath.match(path)){ // check if path reg expr is fulfilled
            //             instance[prop].setPersistent(true);
            //         }
            //     });
            // }
        }

function getInitializedInstance(template, builder, path, dataClass, instanceClass) {
    var instance = getOrInstantiateInstance(template, builder, path, dataClass, instanceClass);
    if(instance && instance.isObservableTreeNode && !instance.instanceInitialized) {
        initializeReferences(template, instance, builder);
        instance.instanceInitialized = true;
    }
    return instance;
}

/**
 * Make sure all instance objects are created (and have the new template as template reference)
 * Do not yet initialize the content
 * Update template references
 */
function instantiateInstances(template, instance, builder, path, dataClass, instanceClass) {
    // update pointer to template
    instance.template(template);
    instance.instanceInitialized = false;

    if (!path[0]) return;
    var collection = template.collections.get(path[0]) || (template.instanceCollections && template.instanceCollections.get(path[0]));
    if (!collection.isOwner()) return;
    var subPath = path.slice(1);
    if (collection.getType() == "value"){
        var child = collection();
        if(child && child.isObservableTreeNode) {
            var child_instance = getOrInstantiateInstance(child, builder, subPath, dataClass, instanceClass);
            instantiateInstances(child, child_instance, builder, subPath, dataClass, instanceClass);
        }
    } else {
        collection.forEach(function(key, child){
            if(child && child.isObservableTreeNode) {
                var child_instance = getOrInstantiateInstance(child, builder, subPath, dataClass, instanceClass);
                instantiateInstances(child, child_instance, builder, subPath, dataClass, instanceClass);
            }
        });
    }
}

/**
 * Create an instance object (do not yet initialize the content)
 */
function instantiateInstance(template, builder, path, dataClass, instanceClass){
    // Find corresponding instance constructor for this object
    var constructor = AutoInstance;
    if (path && path.length == 0) {
        var match = false, testObj = template;
            while (!match && testObj){
            match = (testObj instanceof dataClass);  // search for dataClass in instanceChain (similar to instanceOf that searches in prototype chain
                testObj = testObj.template && testObj.template();
            }
        if (match) constructor = instanceClass;
        }

    // Make new instance Object in builder root
    var instance = new constructor(template);
    initializeInstanceMembers(template, instance, builder, path, dataClass, instanceClass);

    //TODO: remove
    builder.instanceMap.put(template, instance);

    // store pointer to template
    instance.template(template);
    return instance;
}

/**
 * Get the instance object corresponding with value, or create it if it doesn't exist yet (do not yet initialize the content)
 */
function getOrInstantiateInstance(value, builder, path, dataClass, instanceClass){
    if (value == undefined) return null;
    if (value == builder.ancestor()) return builder;
    if (!value.isObservableTreeNode) return null;
    var instance = getInstance(value, builder); // check if value is already instantiated
    if (instance){
        // if (instance.persistent && !instance.template()){ // in case of persisent instanceObject already exist (by dejsonify)
        //     instance.local_id = getInstanceId(value, builder)[1];
        //     initializeInstanceMembers(value, instance, builder);  // rebuild non-persistent part of instance
        // }
        if (!instance.instanceInitialized && path != undefined) initializeInstanceMembers(value, instance, builder, path, dataClass, instanceClass);
        return instance;
    }
    else if (value.isChildOf(builder.ancestor())) return instantiateInstance(value, builder, path, dataClass, instanceClass); // if object is not yet instantiated, check if it needs to be instantiated, i.e. the original object is a child (or grandchild) of the ancestor
    else return value; // if object doesn't need to be instantiated, return original object
}

/**
 * Get the instance object corresponding with value
 */
function getInstance(value, builder){
    return builder.instanceMap.get(value);
}
